// extracted by mini-css-extract-plugin
export default {"fileDropZone":"ProductImages_fileDropZone__fcxx8","descr":"ProductImages_descr__xmaiK","dragOver":"ProductImages_dragOver__ZwQPi","errorMessage":"ProductImages_errorMessage__IG-Pn"};